<style lang="less" scoped>
.contain {
    height: 100%;
    display: flex;
    flex-direction: column;
    .tree-contain {
        margin: 10px 0;
        padding: 10px;
        flex: 1;
        border: solid 1px #dcdee2;
        border-radius: 5px;
        overflow: auto;
    }
}
.header {
  display: flex;
  h3 {
    line-height: 24px;
  }
  .group {
    flex: 1;
    text-align: right;
  }
}
</style>
<template>
  <div>
    <Drawer
      v-model="showModal"
      class="modal"
      :title="modalTitle"
      :closable="false"
      :mask-closable="false"
      width="800"
    >
      <div
        slot="header"
        class="header"
      >
        <h3 style="display:inline-block">
          {{ modalTitle }}
        </h3>
        <div
          class="group"
        >
          <Button
            style="margin-right:10px"
            size="small"
            @click="cancel"
          >
            取消
          </Button>
          <Button
            type="primary"
            :loading="savingLoading"
            size="small"
            @click="ok"
          >
            保存
          </Button>
        </div>
      </div>
      <div class="contain">
        <div>
          <div style="position:relative">
            <Spin
              v-if="getAppListLoading"
              size="small"
              fix
            />
            <Select
              v-if="display===1"
              v-model="selectedApp"
              style="width:200px"
              placeholder="请选择需要添加的app"
              @on-select="selectProject"
            >
              <Option
                v-for="item in appList"
                :key="item.id"
                :value="item.id"
                :disabled="appListHash[item.id]||item.del"
              >
                {{ item.name }}
                <span v-show="appListHash[item.id]">[拥有]</span>
                <span v-show="item.del">[禁用]</span>
              </Option>
            </Select>
          </div>
        </div>
        <div style="margin-top:10px">
          <Collapse v-model="collapseVal">
            <Panel name="1">
              {{ collectDetail.name|| '--' }}
              <div slot="content">
                <p>app_token：{{ collectDetail.app_token|| '--' }}</p>
                <p>remark：{{ collectDetail.remark|| '--' }}</p>
                <p>
                  网址：<a
                    :href="collectDetail.home_page|| '--'"
                    target="_blank"
                  >{{ collectDetail.home_page|| '--' }}</a>
                </p>
              </div>
            </Panel>
          </Collapse>
          </Collapse>
        </div>
        <div
          class="tree-contain"
          style="position:relative"
        >
          <Spin
            v-if="getAppTreeLoading"
            size="large"
            fix
          />
          <TreeNew
            v-if="tree.length!==0"
            ref="treeNew"
            :tree-data="tree"
            :could-checkout="true"
            :could-edit="false"
            :could-select="false"
            :could-grag="false"
          />
        </div>
      </div>
    </Drawer>
  </div>
</template>
<script>
  import TreeNew from '../../components/TreeNew'
  import { collectCheckedItems } from '../../utils'
  export default {
    components: { TreeNew },
    props: {
      display: {
        type: Number,
        default:() => 0
      },
      formProps: {
        type:Object,
        default:() => ({})
      },
      saveloading:{
        type:Boolean,
        default:() => false
      },
      selectedPeople: {
        type: Array,
        default:() => []
      },
      appList: {
        type: Array,
        default:() => []
      },
      tree: {
        type: Array,
        default:() => []
      },
      getAppListLoading: {
        type:Boolean,
        default:() => false
      },
      getAppTreeLoading: {
        type:Boolean,
        default:() => false
      },
      savingLoading: {
        type:Boolean,
        default:() => false
      },
      appListHash: {
        type:Object,
        default:() => ({})
      }
    },
    data() {
      return {
        split1: 0.5,
        modalTitle:'',
        showModal: false,
        selectedPeopleClone: [],
        selectedApp:'',
        collapseVal:''
      }
    },
    computed: {
      collectDetail() {
        return this.tree[0] || {}
      }
    },
    watch: {
      display(value) {
        if (value === 1) {
          this.modalTitle = '新增app权限'
          this.selectedApp = ''
        }
        if (value === 2) {
          this.modalTitle = '编辑app权限'
        }
        if (value === 0) {
          this.showModal = false
          this.collapseVal = ''
        } else {
          this.showModal = true
        }
      },
    },
    methods: {
      selectProject(data) {
        this.$emit('projectChange', {id:data.value})
      },
      ok() {
        const refTree = this.$refs.treeNew.treeDataOwn[0]
        const selectedIds = collectCheckedItems(refTree.items || [])
        if (selectedIds.length === 0) {
          this.$Message.warning({
            content:'无数据可提交',
            duration: 1
          })
          return
        }
        this.$emit('ok', {
          route_app_id:refTree.id,
          route_menu_item_ids:selectedIds
        })
      },
      cancel() {
        this.$emit('cancel')
      }
    }
  }
</script>
